module.exports = __webpack_public_path__ + "img/CREDIT_CARD.ac6735cc.svg";